

















































































import { Component, PropSync, Mixins, Watch } from 'vue-property-decorator'
import Modals from '@ustra/nuxt/src/vue/mixins/modal'
import { HsComponent } from '@hds/help-common/src/components/hs-components'
import * as ConstantKey from '@hds/help-common/src/utils/constant-keys'
import InqrDialog from '@hds/help-common/src/components/inqr/InqrDialog.vue'
import MyFavoriteMenu from '~/components/layout/MyFavoriteMenu.vue'
import RecentMenu from '~/components/layout/RecentMenu.vue'
import vencdEventBus from '~/event-bus/vencd-event-bus'

@Component({
  components: {
    MyFavoriteMenu,
    RecentMenu,
    InqrDialog,
  },
})
export default class extends Mixins(Modals, HsComponent) {
  // #region variables
  @PropSync('gnbDrawer', { default: false }) visible: boolean
  drawerMenuTab = null
  askDialog: boolean = false

  get isApp() {
    return this.$ustra.mobile.isNativeRequest
  }

  get userNm() {
    return this.$ustra.hs.store.auth.currentUser.userNm
  }

  get adminUser() {
    return this.$ustra.hs.store.auth.currentUser.userGbcd === ConstantKey.ADMIN_ROLE
  }

  get gnbHeaderTitle() {
    let headerTitle = ''
    if (this.$ustra.hs.store.auth.currentUser.userGbcd === ConstantKey.ADMIN_ROLE) {
      headerTitle = this.$ustra.hs.store.auth.currentUser.ven2Nm || this.$ustra.hs.store.auth.currentUser.venNm
    } else {
      headerTitle = this.$ustra.hs.store.auth.currentUser.userNm
    }
    return headerTitle
  }

  get gnbItems() {
    if (this.$ustra.hs.store.auth.currentUser.userGbcd === ConstantKey.ADMIN_ROLE) {
      return this.$ustra.hs.store.menuData.menus
    } else {
      return this.$ustra.hs.store.menuData.beqmtMenus
    }
    // if (window.location.pathname.startsWith('/beqmt')) {
    //   return this.$ustra.hs.store.menuData.beqmtMenus
    // } else {
    //   return this.$ustra.hs.store.menuData.menus
    // }
  }

  // #endregion
  // #region hooks

  // #endregion
  // #region methods
  hide() {
    this.visible = false
  }

  async logout() {
    if (await confirm('로그아웃 하시겠습니까?')) {
      this.$ustra.hs.auth.logout(true, true)
    }
  }

  onClickVendorChoice() {
    vencdEventBus.emit({ activeAlert: false })
  }

  // djyoo 21.08.10 설정 연결
  onClickSetting() {
    this.$ustra.mobile.bridge.callNative({
      id: 'IF_COMMON',
      data: {
        type: '02',
      },
    })
  }
  openEduLink() {
    window.location.href = 'https://youtu.be/pCVtrWyl8TM?si=Dp7BlklckMy6EWrw'
  }

  toUserInfo() {
    this.$ustra.router.push('/co/userInfoCert')
  }

  toInqr() {
    this.$ustra.router.push('/co/inqr')
  }

  // #endregion
  // #region watches
  @Watch('visible')
  valueChanged(value: boolean) {
    // console.log('Drawer visible Watch-----------------', this.visible, document.getElementsByClassName('v-dialog__content--active').length, document.querySelector('html').classList)
    if (value) {
      // @ts-ignore
      Modals.options.methods._showModal.call(this)
      this.$nextTick(function () {
        document.documentElement.setAttribute('data-gnb-expand', 'true')
      })
    } else {
      // @ts-ignore
      Modals.options.methods._hideModal.call(this)
      this.$nextTick(function () {
        document.documentElement.setAttribute('data-gnb-expand', 'false')
      })
    }
  }
  // #endregion
}
